import { IHttpAgent } from '@sparelabs/http-client-utils'
import { IJourneyOptionsRawQueryParams, IJourneyOptionsResponse, Resources } from '../types'

/**
 * TODO: create a new lib/multimodal-client for multimodal-service, and move this there.
 */
export class JourneyOptionsResource {
  constructor(private readonly agent: IHttpAgent) {}

  public async list(
    params: IJourneyOptionsRawQueryParams,
    abortSignal?: AbortSignal,
  ): Promise<IJourneyOptionsResponse> {
    const { data } = await this.agent.get<IJourneyOptionsResponse>(Resources.JourneyOptions, {
      params,
      signal: abortSignal,
    })
    return data
  }
}
